import axios from 'axios';

// Empty = same origin (the PHP API lives under /api on the same host). Set REACT_APP_API_URL for a separate backend.
const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({ baseURL: `${API_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

export const downloadFile = async (url: string, filename: string) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_URL}/api${url}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const blob = await response.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
